<template>
    <v-container class="app-page-container">
    <v-card>
        <v-card-title>
            Personalisation tests
        </v-card-title>
        <v-card-text>
            <p>Cieľom týchto dotazníkov je identifikovať jedinečné potreby a preferencie každého študenta a na ich základe navrhnúť personalizačné stratégie, aby počas roka dostávali potrebný obsah v čo najviac prispôsobenej forme. 
            Všetky zistenia budú analyzované v anonymizovanej forme a využité výhradne na vedecké účely a návrh optimalizácii systému tak, aby poskytoval obsah v primeranej náročnosti a typoch aktivít zodpovedajúcim profilu učenia. 
            Projekt je realizovaný v rámci aktivít tímu <a href="https://www.fpvai.ukf.sk/sk/vyskum-fpv-ukf/unikatne-laboratoria/50-veda-a-vyskum/vyskumny-profil-pracovisk/oblasti-vyskumu/laboratoria/1876-beha-lab" target="_blank">Behaviorálneho laboratória FPVaI</a>.</p>
            <v-expansion-panels v-model="panels" multiple flat class="px-6">
                <v-expansion-panel v-for="(ptest, index) in persontests.tests" :key="index">
                    <v-expansion-panel-header>
                        <v-row>
                            <v-col cols="4">
                                <h3>{{ptest.test_name}} ({{ptest.test_count}}/{{ptest.rpt}})</h3>
                            </v-col>
                            <v-col cols="3">
                                <h3 v-if="ptest.max_score>0">top score: {{ptest.max_score}}</h3>
                            </v-col>
                            <v-col cols="3" class="course-additional-activities background-transparent shadow-none">
                                <v-btn v-if= "ptest.test_count < ptest.rpt" x-small  @click="startTest(ptest.id)">Start</v-btn>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-for="(attempt, index2) in ptest.attempts" :key="index2">
                        <v-row>
                            <v-col cols="4">
                                {{ attempt.time_start}}
                            </v-col>
                            <v-col cols="3">
                               <div v-if="attempt.score>0" >
                                score: {{ attempt.score}}
                               <span v-if="ptest.id==8 || ptest.id==9">({{ attempt.rslt }})</span>
                            
                               </div>
                               <div v-if="attempt.score<0" class="d-flex align-center">
                                <!-- stackovaný bar -->
                                <div v-if="ptest.id==1"
                                    class="stackbar"
                                    :style="stackBarStyle(JSON.parse(attempt.rslt), order1, colors1)"
                                    :title="stackBarTooltip(JSON.parse(attempt.rslt), order1, colors1)"
                                ><p style="margin-top: 10px;">{{ attempt.rslt }}</p></div>                                
                                <div v-if="ptest.id==2"
                                    class="stackbar"
                                    :style="stackBarStyle(JSON.parse(attempt.rslt), order2, colors2)"
                                    :title="stackBarTooltip(JSON.parse(attempt.rslt), order2, colors2)"
                                ><p style="margin-top: 10px;">{{ attempt.rslt }}</p></div>
                                <div v-if="ptest.id==10"
                                    class="stackbar"
                                    :style="stackBarStyle(JSON.parse(attempt.rslt), order3, colors3)"
                                    :title="stackBarTooltip(JSON.parse(attempt.rslt), order3, colors3)"
                                ><p style="margin-top: 10px;"></p></div>
                                 <div v-if="ptest.id==11"
                                    class="stackbar"
                                    :style="stackBarStyle(JSON.parse(attempt.rslt), order11, colors11)"
                                    :title="stackBarTooltip(JSON.parse(attempt.rslt), order11, colors11)"
                                ><p style="margin-top: 10px;">{{ attempt.rslt }}</p></div>
                                
                                
                                </div>

                            </v-col>
                            <v-col cols="3"></v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
    </v-card>
</v-container>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            persontests: [],
            panels: [0],
            order1: ['A','S','E','K'],
            colors1: { A:'#3b82f6', S:'#22c55e', E:'#f59e0b', K:'#ef4444' }, // modrá, zelená, oranžová, červená
            order2: ['INV','FOC','EMO'],
            colors2: { INV:'#3b82f6', FOC:'#22c55e', EMO:'#ef4444'},// farby
            order3: ['Planning','Knowledge','Regulation', 'Motivation', 'Global'],
            colors3: { Planning:'#3b82f6', Knowledge:'#bbbbbb', Regulation:'#aa0044', Motivation:'#f59e0b', Global:'#ef4444'},// farby
            order11: ['CI','OP','RP', 'SE'],
            colors11: { CI:'#3b82f6', OP:'#bbbbbb', RP:'#aa0044', SE:'#f59e0b'},// farby
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            axios.get('/get-my-person-tests', this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    // console.log(res.data)
                    this.persontests = res.data
                    const bc = [ { text: 'Personalisation tests', href: '/personalisation_tests/' }, ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        startTest(_id) {
            this.$router.push({name:'personalisation_test', params: {id : _id}})  
        },
        stackBarStyle(counts, order, colors) {
            const total = Math.max(1, order.reduce((s,k)=> s + (counts[k]||0), 0))
            let acc = 0
            const stops = []
            order.forEach(k => {
                const w = (counts[k] || 0) * 100 / total
                const start = acc
                const end = acc + w
                acc = end
                const c = colors[k]
                stops.push(`${c} ${start}%`, `${c} ${end}%`)
            })
            return {
                background: `linear-gradient(to right, ${stops.join(', ')})`
            }
            },
        stackBarTooltip(counts, order, colors) {
            const total = order.reduce((s,k)=> s + (counts[k]||0), 0)
            return order
                .map(k => `${k}: ${counts[k]||0} (${ total? Math.round((counts[k]||0)*100/total):0 }%)`)
                .join(' · ')
            }
    }
}
</script>
<style>
.stackbar {
  height: 12px;
  min-width: 160px;   /* uprav podľa potreby */
  border-radius: 999px;
  background: #eee;   /* fallback */
}
</style>